import { AbstractRequirementMapper } from '@/features/CompanyQuestions/RequirementMapping/AbstractRequirementMapper';

export class Anzahlobjekte extends AbstractRequirementMapper {
  protected frontendKey = 'leistungsumfang.vermietungObjekteAnzahl';

  public getValues(): number[] {
    return super.getValues().map((v) => Number(v) - 1);
  }
}
